import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

// In storyshots the next/image component doesn't seem to play nicely with the imported
// .png so just sticking with the img element for now

/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { keyframes } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import trackClickEvents, { categories, labels } from '../analytics/trackEvents';
import backgroundImage from './disney-100-cvp-bg.png';
import celebrateDisney100WithWestfield from './celebrate-disney-100-with-westfield.png';
import findOutMore from './find-out-more.png';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const scrollToNext = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n\n  42% {\n    top: 0;\n  }\n\n  50% {\n    top: -150%;\n  }\n\n  92% {\n    top: -150%;\n  }\n\n  100% {\n    top: -300%;\n  }\n\n  "])));

const CVPStripImg = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    justify: "center",
    minHeight: "size-xs",
    height: "size-full",
    sx: {
      position: 'relative',
      color: 'licorice',
      '&:last-child': {
        display: ['flex', 'flex', 'flex', 'none']
      }
    },
    shouldWrapChildren: false,
    "data-id": "cvp-strip_index_CVPStripImg_Stack",
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        marginLeft: 'spacing-2xl',
        marginRight: 'spacing-2xl'
      },
      "data-id": "cvp-strip_index_CVPStripImg_Stack_Box",
      children: children
    })
  });
};

const CVPStrip = _ref2 => {
  let {
    country
  } = _ref2;
  return /*#__PURE__*/_jsx(Box, {
    as: "a",
    href: country === 'Australia' ? '/explore/disney100' : '/',
    sx: {
      display: 'block',
      backgroundImage,
      backgroundSize: 'auto var(--chakra-sizes-size-xs)',
      backgroundRepeat: 'repeat',
      backgroundPositionX: 'center'
    },
    onClick: () => trackClickEvents.clicked(categories.UNIVERSAL_HEADER, labels.BENEFITS_STRIP),
    "data-id": "cvp-strip_index_CVPStripImg_Box_2",
    children: /*#__PURE__*/_jsx(CoreContainer, {
      sx: {
        position: 'relative',
        height: 'size-xs'
      },
      "data-id": "cvp-strip_index_CVPStripImg_Box_CoreContainer",
      children: /*#__PURE__*/_jsxs(Stack, {
        gap: "spacing-md",
        align: ['center', 'center', 'center', 'flex-end'],
        justify: ['flex-start', 'flex-start', 'flex-start', 'space-between'],
        direction: ['column', 'column', 'column', 'row'],
        shouldWrapChildren: false,
        flexBasis: ['size-full', 'size-full', 'size-full', 'auto'],
        flexGrow: [1, 1, 1, 1],
        flexShrink: [0, 0, 0, 1],
        minWidth: ['size-full', 'size-full', 'size-full', 'unset'],
        sx: {
          animation: "".concat(scrollToNext, " 12s linear 1"),
          overflowY: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          '@media (min-width: 60em)': {
            animation: 'none'
          }
        },
        "data-id": "cvp-strip_index_CVPStripImg_CoreContainer_Stack",
        children: [/*#__PURE__*/_jsx(CVPStripImg, {
          "data-id": "cvp-strip_index_Stack_CVPStripImg",
          children: /*#__PURE__*/_jsx("img", {
            src: celebrateDisney100WithWestfield,
            width: 257,
            height: 21,
            alt: "",
            "data-id": "cvp-strip_index_CVPStripImg_img"
          })
        }), /*#__PURE__*/_jsx(CVPStripImg, {
          "data-id": "cvp-strip_index_Stack_CVPStripImg",
          children: /*#__PURE__*/_jsx("img", {
            src: findOutMore,
            width: 98,
            height: 21,
            alt: "",
            "data-id": "cvp-strip_index_CVPStripImg_img"
          })
        }), /*#__PURE__*/_jsx(CVPStripImg, {
          "data-id": "cvp-strip_index_Stack_CVPStripImg",
          children: /*#__PURE__*/_jsx("img", {
            src: celebrateDisney100WithWestfield,
            width: 257,
            height: 21,
            alt: "",
            "data-id": "cvp-strip_index_CVPStripImg_img"
          })
        })]
      })
    })
  });
};

export default CVPStrip;